const Card = ({ obj }) => {
  function cleanHTML(string) {
    return string.replace(/<[^>]+>/g, " ").replace(/&nbsp;/g," ");
  }

  function formatDate(obj) {
    const date = new Date(obj.events[0].starts_at).toDateString();
    return <p className="date">{`${date.slice(4, -5)}, ${date.slice(-5)}`}</p>;
  }

  return (
    <div className="event-card">
      <img src={obj.featured_image} alt={obj.name} />
      <div className="info">
        <p className="jalopy">Jalopy Theatre</p>
        <p className="title">{obj.name}</p>
        <p className="description">{cleanHTML(obj["description"])}</p>
        {!!obj.events.length ? (
          formatDate(obj)
        ) : (
          <p className="date">Contact us for scheduling</p>
        )}
        <div className="buttons">
          <a href={obj.url} target="_blank" rel="noreferrer noopener">
            <button
              className="tickets-btn"
              onTouchStart={(e) => e.preventDefault()}
            >
              TICKETS
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Card;
